module.exports = __webpack_public_path__ + "img/sample.141fbff0.jpg";